<div class="title">{{message.subject}}</div>
<div class="date">{{message.from | amDateFormat: 'DD.MM.YYYY'}}</div>

<div class="description" (click)="goto(message.route)">{{message.body}}</div>

